export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    doAction(notification) {
      let action = this.getAction(notification)
      if (Object.keys(action).length > 0) {
        let params = action.link.params ? action.link.params : {}
        params.fromNotification = true
        this.$router.push({ name: action.link.name, params: params })
      }
    },
    getAction(notification) {
      let response = {}
      switch (notification.type) {
        case 'LOW_VOLUME':
          response.link = {
            name: 'reports-view',
            params: { name: 'CurrentOilVolume' },
          }
          this.setFilters('CurrentOilVolume', {
            common: {
              postcodeFrom: '',
              postcodeTo: '',
              serial: notification.extraParameters.plugId,
            },
            custom: { currentVolume: { comparison: 'more', value: null } },
          })
          break
        case 'POOR_BATTERY':
          response.link = {
            name: 'alerts-view',
            params: { name: 'PoorBattery' },
          }
          this.setFilters('PoorBattery', {
            common: {
              postcodeFrom: '',
              postcodeTo: '',
              serial: notification.extraParameters.plugId,
            },
            custom: {},
          })
          this.setSettings('PoorBattery', 100)
          break
        case 'REFILL':
          response.link = {
            name: 'alerts-view',
            params: { name: 'ToppingUpOil' },
          }
          this.setFilters('ToppingUpOil', {
            common: {
              postcodeFrom: '',
              postcodeTo: '',
              serial: notification.extraParameters.plugId,
            },
            custom: {},
          })
          this.setSettings('ToppingUpOil', 0.001)
          break
        case 'INVALID_MEASUREMENT':
          response.link = {
            name: 'invalidEvents',
            params: { id: notification.extraParameters.plugId },
          }
          break
        case 'DEVICE_ASSIGNMENT':
          if (notification.extraParameters.organisationId) {
            response.link = {
              name: 'workshop',
              params: { id: notification.extraParameters.organisationId },
            }
          }
          break
        case 'NOT_INITIALIZED':
          response.link = {
            name: 'alerts-view',
            params: { name: 'MergedButNotInitializedPlugs' },
          }
          this.setFilters('MergedButNotInitializedPlugs', {
            common: {
              postcodeFrom: '',
              postcodeTo: '',
              serial: notification.extraParameters.plugId,
            },
            custom: {},
          })
          break
        case 'SHIPMENT_MISTAKE':
          response.link = {
            name: 'alerts-view',
            params: { name: 'ShipmentMistakes' },
          }
          this.setFilters('ShipmentMistakes', {
            common: {
              postcodeFrom: '',
              postcodeTo: '',
              serial: notification.extraParameters.plugId,
            },
            custom: {},
          })
          break
      }
      return response
    },
    setFilters(name, filters) {
      this.$store.commit('filters/SET_FILTERS', {
        name: name,
        item: filters,
      })
    },
    setSettings(name, settings) {
      this.$store.commit('settings/SET_SETTINGS', {
        name: name,
        params: settings,
      })
    },
  },
}
